function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import { EMAIL_ADDRESSES, NUMBERS_ONLY_OR_BLANK } from 'invision-core/src/constants/validation.constants';
import i18n from 'invision-core/src/components/i18n/i18n';
import CustomerCareKeys from '../../../../../locales/keys';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataOptionsForCodeValuesWithoutPlaceholderSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CustomerSearchResultsViewModelSelector } from '../../../../../reducers/selectors/search.other.customers.selectors';
import { CurrentCustomerSelector } from '../../../../../reducers/selectors/customer.selectors';
import { resetSearchOtherCustomersStore, searchExistingCustomers, searchHouseholdMembers } from '../../../../../reducers/actions/search.other.customers.actions';
import { SearchIsFetchingResultsSelector } from '../../../../../reducers/selectors/search.selectors';
var CUSTOMER_SEARCH_TYPE = {
  EXISTING_CUSTOMER: 1,
  HOUSEHOLD_MEMBER: 2
};
var customerSearchDialogController = /*#__PURE__*/function () {
  function customerSearchDialogController($ngRedux, uiNotificationService) {
    _classCallCheck(this, customerSearchDialogController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CoreLocaleKeys: CoreLocaleKeys,
      CUSTOMER_SEARCH_TYPE: CUSTOMER_SEARCH_TYPE,
      CustomerCareKeys: CustomerCareKeys,
      customErrorMessages: [],
      customerIdNumericErrorMessage: {
        pattern: i18n.translate(CustomerCareKeys.SEARCH_ERRORS_CUSTOMER.SUBSCRIBERID_FORMAT_ERROR)
      },
      customerSearchModel: {},
      customerSearchTypeOptions: [{
        id: CUSTOMER_SEARCH_TYPE.EXISTING_CUSTOMER,
        text: i18n.translate(CustomerCareKeys.SEARCH_OTHER_CUSTOMER.EXISTING_CUSTOMER),
        selected: true
      }, {
        id: CUSTOMER_SEARCH_TYPE.HOUSEHOLD_MEMBER,
        text: i18n.translate(CustomerCareKeys.SEARCH_OTHER_CUSTOMER.HOUSEHOLD_MEMBER),
        selected: false
      }],
      EMAIL_ADDRESSES: EMAIL_ADDRESSES,
      firstNameRequiredErrorMessage: {
        required: i18n.translate(CustomerCareKeys.SEARCH_OTHER_CUSTOMER.DEPENDENT_REQUIRED_ERROR_MESSAGE, {
          subjectField: i18n.translate(CustomerCareKeys.SEARCH_FIELDS_CUSTOMER.FIRST_NAME),
          dependentField: i18n.translate(CustomerCareKeys.SEARCH_FIELDS_CUSTOMER.LAST_NAME),
          prefixDependentField: i18n.translate(CustomerCareKeys.PREFIX)
        })
      },
      lastNameRequiredErrorMessage: {
        required: i18n.translate(CustomerCareKeys.SEARCH_OTHER_CUSTOMER.DEPENDENT_REQUIRED_ERROR_MESSAGE, {
          subjectField: i18n.translate(CustomerCareKeys.SEARCH_FIELDS_CUSTOMER.LAST_NAME),
          dependentField: i18n.translate(CustomerCareKeys.SEARCH_FIELDS_CUSTOMER.FIRST_NAME),
          prefixDependentField: i18n.translate(CustomerCareKeys.PREFIX)
        })
      },
      NUMBERS_ONLY_OR_BLANK: NUMBERS_ONLY_OR_BLANK,
      onCustomerSearchTypeOptionSelected: this.onCustomerSearchTypeOptionSelected.bind(this),
      selectedCustomer: null,
      selectedCustomerSearchType: CUSTOMER_SEARCH_TYPE.EXISTING_CUSTOMER,
      showResults: false,
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(customerSearchDialogController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        resetSearchOtherCustomersStore: resetSearchOtherCustomersStore,
        searchExistingCustomers: searchExistingCustomers,
        searchHouseholdMembers: searchHouseholdMembers
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomer: CurrentCustomerSelector(store),
          customerSearchResultsViewModel: CustomerSearchResultsViewModelSelector(store),
          isFetchingSearchResults: SearchIsFetchingResultsSelector(store),
          personTitleOptions: MetadataOptionsForCodeValuesWithoutPlaceholderSelector(CODES.PersonTitle, store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.resetSearchResultsAndSelectionData();
      this.disconnectRedux();
    }
  }, {
    key: "onCustomerSearchTypeOptionSelected",
    value: function onCustomerSearchTypeOptionSelected(option) {
      var _this2 = this;
      this.customerSearchTypeOptions.forEach(function (option) {
        option.selected = false;
      });
      option.selected = true;
      this.selectedCustomerSearchType = option.id;
      if (this.selectedCustomerSearchType === CUSTOMER_SEARCH_TYPE.EXISTING_CUSTOMER) {
        this.customerSearchModel = {};
        this.showResults = false;
      } else {
        this.actions.searchHouseholdMembers(this.state.currentCustomer.Id).then(function () {
          _this2.showResults = true;
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "showCustomerSearchTypeFilter",
    value: function showCustomerSearchTypeFilter() {
      return this.selectedCustomerSearchType !== CUSTOMER_SEARCH_TYPE.EXISTING_CUSTOMER || !this.showResults;
    }
  }, {
    key: "areAllSearchFieldsEmpty",
    value: function areAllSearchFieldsEmpty() {
      return !this.customerSearchModel.title && !this.customerSearchModel.firstName && !this.customerSearchModel.lastName && !this.customerSearchModel.companyName && !this.customerSearchModel.email && !this.customerSearchModel.customerId && !this.customerSearchModel.phoneNumber;
    }
  }, {
    key: "customErrorsExist",
    value: function customErrorsExist() {
      this.customErrorMessages = [];
      if (this.areAllSearchFieldsEmpty()) {
        this.customErrorMessages.push(i18n.translate(this.CustomerCareKeys.SEARCH_ERRORS_CUSTOMER.EMPTY_FORM_ERROR));
      }
      return !!this.customErrorMessages.length;
    }
  }, {
    key: "onSearchClicked",
    value: function onSearchClicked() {
      var _this3 = this;
      this.customerSearchTypeForm.$submitted = true;
      if (this.customerSearchTypeForm.$valid && !this.customErrorsExist()) {
        this.actions.searchExistingCustomers(this.customerSearchModel).then(function () {
          _this3.showResults = true;
        }).catch(function (error) {
          _this3.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "backToSearchForm",
    value: function backToSearchForm() {
      this.showResults = false;
      this.resetSearchResultsAndSelectionData();
    }
  }, {
    key: "resetSearchResultsAndSelectionData",
    value: function resetSearchResultsAndSelectionData() {
      this.selectedCustomer = null;
      this.actions.resetSearchOtherCustomersStore();
    }
  }, {
    key: "handleSearchResultItemClicked",
    value: function handleSearchResultItemClicked(customer) {
      if (!customer.isDisabled) {
        this.selectedCustomer = customer;
      }
    }
  }]);
}();
export default {
  template: require('./search.other.customer.dialog.html'),
  bindings: {
    additionalText: '<?',
    dialogTitle: '<',
    isLoading: '<',
    onClose: '&',
    onCustomerSelected: '&',
    searchTypeDropdownLabel: '<?',
    viewModel: '<?'
  },
  controller: customerSearchDialogController
};